import React from 'react';
interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
const Input: React.FC<InputProps> = ({
  label,
  error,
  className = '',
  ...props
}) => {
  return <div className="mb-5" data-id="element-179">
      {label && <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-180">
          {label}
        </label>}
      <input className={`w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#E84118] focus:border-[#E84118] ${error ? 'border-red-500' : ''} ${className}`} {...props} data-id="element-181" />
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-182">{error}</p>}
    </div>;
};
export default Input;